declare let BigNumber: any;

import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { AmtAdapter } from "./AmtAdapter";

import { ColumnDefinition } from "../../model/ColumnDefinition";

import { ICcyLookupService } from "../../lookup/model/ICcyLookupService";

export class DealtAmtAdapter extends AmtAdapter {
  constructor(ccyPairLookup: ICcyLookupService) {
    super(ccyPairLookup);
  }

  getCcyCode(order: any): string {
    if (
      order.hasOwnProperty("allocationData") &&
      order.allocationData[0] instanceof CubiqTS.AllocationDataImpl
    ) {
      return order.allocationData[0].fixedCcy;
    }
    return order.fixedCode;
  }
}
